import ApplicationController from './controllers/application'
import migrations from './migrations'
import ApplicationModel from './models/application'
import routes from './routes'
import UserService from './services/user'

export default function pluginInterface(options = {}) {

  require('./hooks/invalidate-cache')

  return routes(options)

}

const resources = {
  controllers: {
    Application: ApplicationController
  },
  models: {
    Application: ApplicationModel
  }
}

const settings = {
  migrations,
  pluginName: 'applications'
}

export {ApplicationController}
export {ApplicationModel}
export {resources}
export {settings}
export {UserService}
